























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { VueEditor, Quill } from 'vue2-editor';
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

var Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px'];
Quill.register(Size, true);

@Component({
    components: {
        VueEditor
    }
})
export default class TextEditor extends Vue {
	internalValue: string | null = null;

	@Prop({ type: String, default: '' })
	value!: string;

	@Prop({ type: String, required: true })
	name!: string;

	@Prop({ type: String, required: false, default: '' })
	label!: string;

	@Prop({ type: [Boolean], default: false })
	disabled!: boolean;

	@Prop({ type: [String, Object], required: false, default: '' })
	rules!: string | object;

	@Prop({ type: Boolean, required: false, default: true })
	showErrors!: boolean;

	@Prop({ type: Boolean, required: false, default: false })
	hideHeading!: boolean;

	@Watch('value')
	onValueChange(value: string) {
	    this.internalValue = value;
	}

	@Watch('internalValue')
	onInternalValueChange(value: any) {
	    this.$emit('input', value);
	}

	get id() {
	    return 'text-editor-' + new Date().valueOf();
	}

	get listeners() {
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    const { input, ...listeners } = this.$listeners;
	    return listeners;
	}

	created() {
	    this.internalValue = this.value;
	}

	fullToolbar: any = [
	    [{ font: [] }],

	    [{ size: ['10px', '12px', '14px', '16px', '18px'] }],

	    ['bold', 'italic', 'underline', 'strike'],

	    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],

	    ['blockquote', 'code-block'],

	    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],

	    [{ script: 'sub' }, { script: 'super' }],

	    [{ indent: '-1' }, { indent: '+1' }],

	    [
	        {
	            color: [
	                '#ffffff',
	                '#ffffcc',
	                '#ffff66',
	                '#ffff00',
	                '#ffebcc',
	                '#ffc266',
	                '#ffc107',
	                '#ff9900',
	                '#fd7e14',
	                '#facccc',
	                '#f06666',
	                '#ebd6ff',
	                '#e83e8c',
	                '#e60000',
	                '#dc3545',
	                '#cce8cc',
	                '#cce0f5',
	                '#c285ff',
	                '#bbbbbb',
	                '#b2b200',
	                '#b26b00',
	                '#a10000',
	                '#9933ff',
	                '#888888',
	                '#6f42c1',
	                '#6b24b2',
	                '#66b966',
	                '#66a3e0',
	                '#666600',
	                '#663d00',
	                '#6610f2',
	                '#5c0000',
	                '#444444',
	                '#3d1466',
	                '#28a745',
	                '#20c997',
	                '#202940',
	                '#17a2b8',
	                '#008a00',
	                '#007bff',
	                '#0066cc',
	                '#006100',
	                '#0047b2',
	                '#003700',
	                '#002966',
	                '#000000'
	            ]
	        },
	        {
	            background: [
	                '#ffffff',
	                '#ffffcc',
	                '#ffff66',
	                '#ffff00',
	                '#ffebcc',
	                '#ffc266',
	                '#ffc107',
	                '#ff9900',
	                '#fd7e14',
	                '#facccc',
	                '#f06666',
	                '#ebd6ff',
	                '#e83e8c',
	                '#e60000',
	                '#dc3545',
	                '#cce8cc',
	                '#cce0f5',
	                '#c285ff',
	                '#bbbbbb',
	                '#b2b200',
	                '#b26b00',
	                '#a10000',
	                '#9933ff',
	                '#888888',
	                '#6f42c1',
	                '#6b24b2',
	                '#66b966',
	                '#66a3e0',
	                '#666600',
	                '#663d00',
	                '#6610f2',
	                '#5c0000',
	                '#444444',
	                '#3d1466',
	                '#28a745',
	                '#20c997',
	                '#202940',
	                '#17a2b8',
	                '#008a00',
	                '#007bff',
	                '#0066cc',
	                '#006100',
	                '#0047b2',
	                '#003700',
	                '#002966',
	                '#000000'
	            ]
	        }
	    ],

	    ['link', 'image', 'video'],

	    [{ direction: 'rtl' }],
	    ['clean']
	];

	editorSettings: any = {
	    modules: {
	        toolbar: {
	            container: this.fullToolbar
	        },
	        imageDrop: true,
	        imageResize: {}
	    }
	};
}
